import React from 'react'

import { Dashboard } from '@components'
import { HeadContent } from '@fourthwall/components'

import { GiveawayPackagesData } from './components/GiveawayPackagesData/GiveawayPackagesData'
import { useGiveawayPackagesQuery } from './queries/useGiveawayPackagesQuery'

export const GiveawayPackages = () => {
  const { giveawayPackagesQuery } = useGiveawayPackagesQuery(undefined, {
    keepPreviousData: true,
  })

  return (
    <>
      <HeadContent title="Giveaway links" />
      <Dashboard.Section.Item>
        <GiveawayPackagesData
          data={giveawayPackagesQuery.data?.packages || []}
          isLoading={giveawayPackagesQuery.isLoading}
        />
      </Dashboard.Section.Item>
    </>
  )
}
